import React, { useState, useEffect } from 'react';
import FrontOfficeSidebar from '../../Components/FrontOfficeSidebar';
import StudentInfoSidebar from '../../Components/StudentInfoSidebar';


const StudentinfoLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
  const checkScreenSize = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
    setIsSidebarOpen(false); // Always start closed
  };

  checkScreenSize();
  window.addEventListener('resize', checkScreenSize);

  return () => window.removeEventListener('resize', checkScreenSize);
}, []);


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Determine content classes
  const getContentClass = () => {
    if (isMobile) return 'layout-content';
    if (isSidebarOpen) return 'layout-content desktop-open';
    return 'layout-content desktop-closed';
  };

  return (
    <div className="layout-container">
      <StudentInfoSidebar 
        isOpen={isSidebarOpen} 
        isMobile={isMobile}
        toggleSidebar={toggleSidebar} 
      />
      
      <div className={getContentClass()}>
        {/* Mobile overlay when sidebar is open */}
        {isMobile && isSidebarOpen && (
          <div 
            className="mobile-overlay"
            onClick={toggleSidebar}
          />
        )}
        
        {children}
      </div>
    </div>
  );
};

export default StudentinfoLayout;